import React, { useState } from "react";
import PropTypes from 'prop-types';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
// @mui
import { Modal, Button, Box, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// other
import { NikkoUtil } from '../../utils';

const modalPortlateStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  boxShadow: 24,
}

const modalLandscapeStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '100%',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const navButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  bgcolor: 'rgba(0, 0, 0, 0.45)',
  color: 'white',
  '&:hover': {
    bgcolor: 'rgba(0, 0, 0, 0.65)',
  },
};

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

PhotoImageZoomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  imageUrl: PropTypes.string,
  isSelectable: PropTypes.bool,
  isChecked: PropTypes.bool,
  canPrev: PropTypes.bool,
  canNext: PropTypes.bool,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  onToggleChecked: PropTypes.func,
  onClose: PropTypes.func.isRequired
};

export default function PhotoImageZoomModal({
  isOpen,
  imageUrl,
  isSelectable = false,
  isChecked = false,
  canPrev = false,
  canNext = false,
  onPrev,
  onNext,
  onToggleChecked,
  onClose
}) {
  // const transformComponentRef = React.useRef;

  const handleDownload = () => {
    NikkoUtil.downloadImage(imageUrl);
  };

  const handleClose = () => {
    onClose();
  };

  const handleToggleChecked = (event) => {
    if (onToggleChecked) {
      onToggleChecked(event.target.checked);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
    <Box>
      <Box sx={modalPortlateStyle}>
        <TransformWrapper sx={{ position: 'absolute' }} limitToBounds={true} maxPositionX='-20%' >
          <React.Fragment>
              <TransformComponent>
                <StyledProductImg src={imageUrl} />
              </TransformComponent>
          </React.Fragment>
        </TransformWrapper>

        {canPrev && (
          <IconButton
            aria-label='previous'
            size='large'
            onClick={onPrev}
            sx={{ ...navButtonStyle, left: 8 }}
          >
            <ChevronLeftIcon fontSize="inherit" />
          </IconButton>
        )}
        {canNext && (
          <IconButton
            aria-label='next'
            size='large'
            onClick={onNext}
            sx={{ ...navButtonStyle, right: 8 }}
          >
            <ChevronRightIcon fontSize="inherit" />
          </IconButton>
        )}
      </Box>
      {/* 閉じるボタン：画面上部に固定 */}
      <Box
        display="flex"
        justifyContent="flex-end"
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          zIndex: 1400,
        }}
      >
        <IconButton aria-label='close' size='large' onClick={handleClose}
          sx={{ bgcolor: 'rgba(255,255,255,0.85)', m: 1, '&:hover': { bgcolor: 'rgba(255,255,255,1)' } }}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </Box>

      {/* 選択・ダウンロード：画面下部に固定 */}
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
          opacity: 0.9,
          zIndex: 1400,
          px: 1,
        }}
      >
        <IconButton aria-label='download' size='large' onClick={handleDownload} sx={{ mr: 'auto' }}>
          <FileDownloadIcon fontSize="inherit" />
        </IconButton>
        {isSelectable && (
          <FormControlLabel
            sx={{ mr: 1 }}
            control={<Checkbox checked={isChecked} onChange={handleToggleChecked} />}
            label={<Typography variant='body2'>選択</Typography>}
          />
        )}
      </Box>
    </Box>
    </Modal>
  );
}

